export default __webpack_public_path__ + "static/media/Astro_Aquarius_White.067a4a26.png";